// extracted by mini-css-extract-plugin
export default {"section":"EmployeeCarousel_section__fzANM"};